import * as React from "react";
const SvgArrowLeft = props => <svg width={16} height={15} viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.5 13.5L1.5 7.5L7.5 1.5M2.33333 7.5L14.5 7.5" fill="none" stroke="currentColor" /></svg>;
export default SvgArrowLeft;